import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
  ChildComponentRef,
} from "shared-component/autocomplete-checkbox-multiple";
import {
  selectedListValues,
} from "utility/helper";
import { listItemProp } from "utility/types";
import SignalModal from "./signalModalComponent";
import VinSelectionModal from "./vinModalComponent";

export interface ScatterPlotFilterComponentProps {
  vinListTimeSeries: string[];
  aggregateType?: any;
  signalList: any;
  groupBy: any;
  setSelectedVinList: (value: any) => void;
  setSelectedVinListVisualization: (value: any) => void;
  selectedVINs: string[];
  handleSelectedVinGroup: any;
  setSelectedSignalGroup: any;
  selectedVinGroup: any;
}

const ScatterPlotFilterComponent = (props: ScatterPlotFilterComponentProps) => {
  const [vinList, setVinList] = useState<string[]>([]);
  const [signalList, setSignalList] = useState<string[][]>([]);
  const [groupBy, setGroupBy] = useState<string[]>([]);
  const [aggregateType, setAggregateType] = useState<string[]>([]);
  const childRef = useRef<ChildComponentRef>({ clearSelection: () => {} });
  const [/*signalSelectionLimitReached*/, setSignalSelectionLimitReached] = useState<boolean>(false);

  const vinListData = props?.vinListTimeSeries;
  const groupByData = props?.groupBy;
  const aggregateList = props?.aggregateType;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVinModalOpen, setIsVinModalOpen] = useState(false);
  const [signalPairs, setSignalPairs] = useState<
    { signal1: string; signal2: string }[]
  >([]);
  const [/*textValue*/, setTextValue] = useState<string>('');

  const handleModalSave = (pairs: { signal1: string; signal2: string }[]) => {
    if (pairs.length > 0 && pairs.every((pair) => pair.signal1 && pair.signal2)) {
        setSignalPairs(pairs);
        const newSignalList = pairs.map(pair => [pair.signal1, pair.signal2]);
        setSignalList(newSignalList);
    }
    setIsModalOpen(false);
};

  const handleSetPairModified = (pairModified: any) => {
    const pairmod = JSON.parse(pairModified)
    if (pairModified && props?.selectedVINs?.length > pairmod && props?.selectedVinGroup?.length > pairmod) {
      const currentSelectedVIN: any = props?.selectedVINs;
      const currentVinGroup: any = props?.selectedVinGroup;
      if(currentSelectedVIN![pairmod]) currentSelectedVIN![pairmod] = []
      if(currentVinGroup![pairmod]) currentVinGroup![pairmod] = { dropdown1: [], dropdown2: [] }
       setVinList(currentSelectedVIN);
      props.handleSelectedVinGroup(currentVinGroup)
  }
}

  const handleSignalSelection = (selectedList: listItemProp[]) => {
    const value: string[] = selectedListValues(selectedList);
    if (value && value?.length >= 0) {
      const newSignalList = [value.slice(0, 2)];
      setSignalList(newSignalList);
      // if (signalPairs.length > 0) {
      //   setSignalPairs(signalPairs);
      // } else {
      //   setSignalPairs([{ signal1: "", signal2: "" }]);
      // }
      setSignalPairs(prevPairs => prevPairs.length > 0 ? prevPairs : [{ signal1: "", signal2: "" }]);
      setIsModalOpen(true);
    } else {
      setSignalList(value.length ? [value] : []);
    }
    setSignalSelectionLimitReached(value?.length > 5 ? true : false);
  };

  const handleGroupBySelection = (selectedList: string[]) => {
    setGroupBy(selectedList);
  };
  const handleAggregateSelection = (selectedList: string[]) => {
    setAggregateType(selectedList);
  };
  const handleVinDropdownClick = () => {
    if (signalPairs.length > 0 && signalList.length > 0) {
      setIsVinModalOpen(true);
    }
  };

  const handleApply = () => {
    props?.setSelectedVinList({ vinList, signalList, groupBy, aggregateType });
    props?.setSelectedSignalGroup(signalPairs);
  };

  const isApplyButtonDisabled = () => {
    return (
      signalList.length === 0 ||
      signalPairs.some((pair) => !pair.signal1 || !pair.signal2) ||
      vinList.length === 0 ||
      groupBy.length === 0 ||
      aggregateType.length === 0
    );
  };

  const handleCancel = () => {
    childRef.current.clearSelection();
    setSignalPairs([]); 
    setIsModalOpen(false); 
    setVinList([]);
    setSignalList([]);
    props.handleSelectedVinGroup([])
    props.setSelectedVinListVisualization([]);
  };

  useEffect(() => {
    if (signalList.length === 0) {
      setVinList([]); 
    }
  }, [signalList]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        justifyContent: "space-evenly",
        gap: "4px",
      }}
    >
      <>
        {signalPairs.length === 0 ? (
          <FormControl style={{ width: "28%" }}>
            <Button
              variant="outlined"
              onClick={() => handleSignalSelection([])}
              style={{ 
                width: "100%", 
                height: "56px", 
                display: 'flex', 
                justifyContent: 'flex-start', 
                alignItems: 'center',
                color: 'rgba(0, 0, 0, 0.7)'
              }}
            >
              Select / Search Signals
            </Button>
          </FormControl>
        ) : (
          <Tooltip 
            title={signalPairs.map(pair => `${pair.signal1} vs ${pair.signal2}`).join(', ')}
            arrow
            placement="right"
          >
            <TextField
              label="Selected Signals"
              variant="outlined"
              // value={signalPairs.map(pair => `${pair.signal1} vs ${pair.signal2}`).join(', ')}
              value={signalPairs.map(pair => pair.signal1 && pair.signal2 ? `${pair.signal1} vs ${pair.signal2}` : '').filter(Boolean).join(', ')}
              style={{ width: "30%", height: "56px" }}
              size="small"
              InputProps={{
                readOnly: true,
                style: { 
                  height: "-webkit-fill-available",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap"
                }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '-webkit-fill-available',
                },
                '& .MuiOutlinedInput-input': {
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }
              }}
              onClick={() => handleSignalSelection([])}
            />
          </Tooltip>
        )}
        {vinList.length === 0 ? (
        <Button
          variant="outlined"
          onClick={handleVinDropdownClick}
          style={{ width: "28%", height: "56px", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', color: (signalPairs.length === 0 || signalList.length === 0) ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0, 0, 0, 0.7)' }}
          disabled={signalPairs.length === 0 || signalList.length === 0}
        >
          Select / Search VINS
        </Button>
        ) : (
        <Tooltip 
          title={vinList.join(', ')}
          arrow
          placement="right"
        >
          <TextField
            label="Selected VINs"
            variant="outlined"
            value={vinList.join(', ')}
            onChange={(e) => setTextValue(e.target.value)}
            style={{ width: "25%", height: "56px" }}
            size="small"
            InputProps={{
              readOnly: true,
              style: { 
                height: "-webkit-fill-available",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap"
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: '-webkit-fill-available',
              },
              '& .MuiOutlinedInput-input': {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }
            }}
            onClick={handleVinDropdownClick}
          />
        </Tooltip>
        )}
        <FormControl style={{ width: "22%" }}>
          <InputLabel htmlFor="grouped-native-select">Group By</InputLabel>
          <Select
            id="modelSelect"
            value={groupBy}
            MenuProps={{ disablePortal: true }}
            onChange={(event) => {
              const {
                target: { value },
              } = event;
              handleGroupBySelection(
                typeof value === "string" ? value.split(",") : value
              );
            }}
            renderValue={(selected) => selected.join(", ")}
            input={<OutlinedInput label="Group By" />}
          >
            {groupByData?.map((item: any, index: number) => (
              <MenuItem key={index} value={item.value}>
                <Checkbox checked={groupBy.indexOf(item?.value) > -1} />
                <ListItemText
                  style={{ textTransform: "capitalize" }}
                  primary={item.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ width: "22%" }}>
          <InputLabel htmlFor="grouped-native-select">Aggregate</InputLabel>
          <Select
            id="modelSelect"
            value={aggregateType}
            MenuProps={{ disablePortal: true }}
            onChange={(event) => {
              const {
                target: { value },
              } = event;
              handleAggregateSelection(
                typeof value === "string" ? value.split(",") : value
              );
            }}
            renderValue={(selected) => selected.join(", ")}
            input={<OutlinedInput label="Aggregate" />}
          >
            {aggregateList?.map((item: any, index: number) => (
              <MenuItem key={index} value={item.value}>
                <Checkbox checked={aggregateType.indexOf(item?.value) > -1} />
                <ListItemText
                  style={{ textTransform: "capitalize" }}
                  primary={item.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            handleApply();
          }}
          size="small"
          sx={{ height: "36px", margin: "8px" }}
          disabled={isApplyButtonDisabled()}
        >
          APPLY
        </Button>
      </div>
      <SignalModal
        isOpen={isModalOpen}
        onClose={handleCancel}
        signals={props.signalList}
        selectedSignals={signalList.flat()}
        initialPairs={signalPairs}
        onSave={handleModalSave}
        setPairModified={handleSetPairModified}
      />
      {isVinModalOpen && (
        <VinSelectionModal
          isOpen={isVinModalOpen}
          onClose={() => setIsVinModalOpen(false)}
          signalPairs={signalPairs}
          vinListData={vinListData}
          onVinSelect={(selectedVins: string | any[] | ((prevState: string[]) => string[])) => {
            // Handle the selected VINS from the modal
            if (typeof selectedVins === 'string') {
              setVinList([selectedVins]);
              // setVinSelectionLimitReached(false);
              props?.setSelectedVinListVisualization([selectedVins]);
            } else if (Array.isArray(selectedVins)) {
              setVinList(selectedVins);
              // setVinSelectionLimitReached(selectedVins.length >= 2);
              props?.setSelectedVinListVisualization(selectedVins);
            } else if (typeof selectedVins === 'function') {
              setVinList(selectedVins);
              // setVinSelectionLimitReached(selectedVins.length >= 2);
              props?.setSelectedVinListVisualization(selectedVins);
            }
            setIsVinModalOpen(false);
          }}
          handleSelectedVinGroup={props.handleSelectedVinGroup}
          selectedVinList={vinList}
          selectedVinGroup={props.selectedVinGroup}
        />
      )}
    </div>
  );
};

export default ScatterPlotFilterComponent;
